import React, {useEffect, useState} from "react";
import {
  apollo_useStyles,
} from "../../atom/Apollo_styles";
import {
  apollo_users_accountgroup_path,
  userdetail_path,
} from "../../atom/Apollo_links";
import {
  User,
} from "../../organism/ACCOUNT/AccountModel";
import {useHistory, useParams} from "react-router-dom";
import {ApolloAxios} from "../../atom/Apollo_ApiRequest3";
import {ApolloMessage} from "../../atom/Apollo_Mesasge";
import {ApolloDataTable, STORAGE_KEY} from "../../atom/Apollo_DataTable";
// 認証期間切れの処理
import {ApolloExpired} from "../../atom/Apollo_Expired";

import KeyboardArrowRightIcon from '@material-ui/icons/KeyboardArrowRight';
import Card from "@material-ui/core/Card/Card";
import {createMuiTheme} from "@material-ui/core/styles";
import {SelectableRows} from "mui-datatables";
import {MuiThemeProvider} from "@material-ui/core";
import Collapse from "@material-ui/core/Collapse/Collapse";

// エラーメッセージ
const ERROR_MESSGAE = [
  "ユーザー情報の取得に失敗しました。",
];

/*
    ユーザーリスト表示
 */
const ApolloUserList = (props: {openuser: boolean}) => {

  const {accountgroupid} = useParams<{accountgroupid: string}>();

  const classes = apollo_useStyles();
  const history = useHistory();
  const {data, setmsg} = React.useContext(ApolloMessage);
  const [users, setUsers] = useState<User[]>([]);

  useEffect(() => {
   if (props.openuser) {
      const url = apollo_users_accountgroup_path + accountgroupid;
      ApolloAxios.get(url).then(response => {
        setUsers(response.data.result);
      }).catch(err => {
        // 認証期間切れ判定とエラーメッセージ表示
        if (!ApolloExpired(err, ERROR_MESSGAE[0], data, setmsg, history)) {
          // 認証期間切れ以外のエラーで、エラーメッセージ表示後の処理があれば記述
        }
      });
    }
  }, [props.openuser]);

  const theme = createMuiTheme({});
  // カラムリスト
  const columns = [
    {
      name: "mailaddress",
      label: "メールアドレス",
      options: {
        filter: true,
        sort: true,
      }
    },
    {
      name: "familyName",
      label: "氏名（姓）",
      options: {
        filter: true,
        sort: true,
      }
    },
    {
      name: "firstName",
      label: "氏名（名）",
      options: {
        filter: true,
        sort: true,
      }
    },
    {
      name: "organization",
      label: "所属会社",
      options: {
        filter: true,
        sort: true,
      }
    },
    {
      name: "roleNames",
      label: "管理権限",
      options: {
        filter: true,
        sort: true,
      }
    },
    {
      name: "",
      label: "詳細",
      options: {
        filter: false,
        sort: false,
        customBodyRenderLite: (idx: number) => {
          return (
            <KeyboardArrowRightIcon
              onClick={() => history.push(userdetail_path + users[idx].userId + "?type=ac")}
              className={classes.link}
              style={{cursor: "pointer"}}
            />
          );
        }
      },
    },
  ];

  const selectableRows: SelectableRows = 'none';
  // リストオプション
  const options = {
    filter: true,
    download: false,
    print: false,
    sort: true,
    selectableRows: selectableRows,
    rowsPerPage: 10,
    rowsPerPageOptions: [10, 25, 50],
    jumpToPage: true,
    expandableRows: false,
    expandableRowsHeader: false,
    expandableRowsOnClick: false,
    storageKey: STORAGE_KEY.APOLLO_USER_LIST,
  }

  return (
    <Collapse in={props.openuser} timeout="auto" unmountOnExit>
      <Card className={classes.root} square variant="outlined">
        <MuiThemeProvider theme={theme}>
          <ApolloDataTable
            title=""
            data={users ? users : []}
            columns={columns}
            options={options}
          />
        </MuiThemeProvider>
      </Card>
    </Collapse>
  );
}
export default ApolloUserList;
